module.exports = __webpack_public_path__ + "img/Metastasis-BRCA_SpatialResearch.43a26c0a.png";